import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Schedule_Interface } from 'src/app/Interface/Schedule_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ScheduleService {

  constructor(private http:HttpClient) { }


  GetRecord(Token:String,id:number,persianDate:string):Observable<Array<Schedule_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Schedule?token=" + Token
      + "&id=" + id
      + "&persianDate="+persianDate).pipe(
      map(data=>{
        return data as Array<Schedule_Interface>
      })
    )
  }

  Status(Token:String,id:number):Observable<any>{
    return this.http.get(environment.BaseUrl + "Daro/Schedule/Status?token=" + Token
      + "&id=" + id).pipe(
      map(data=>{
        return data as any
      })
    )
  }

  Delete(Token: String, id: number): Observable<any>{
    return this.http.get(environment.BaseUrl + "Daro/Schedule/Delete?token=" + Token
      + "&id=" + id).pipe(
      map(data=>{
        return data as any
      })
    )
  }

  Submit(dsc: string,
    persianDate: string,
    expert_id: number,
    type_id: number,
    letter_schedule: Array<number>,
    Token: String): Observable<any>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      dsc:dsc,
      token:Token,
      persianDate:persianDate,
      expert_id:expert_id,
      type_id:type_id,
      letter_schedule: letter_schedule,
    }

    return this.http.post(environment.BaseUrl + "Daro/Schedule/Submit",body,{headers}).pipe(
      map(data=>{
        return data as any
      })
    )
  }

}
